<div class="form-page">
    <div class="steps-grafic">
        <app-registry-steps-grafic></app-registry-steps-grafic>
    </div>
    <div class="text-container-right">
        <app-registry-confirmation class="right-container-width"></app-registry-confirmation>
    </div>
</div>